import React from "react";

const GDeskWorksCard = ({ stepNumber, title, description, icon }) => {
  return (
    <div className="bg-white border-1 border-gray-300 rounded-xl shadow-lg p-6 text-center hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group border border-gray-100 hover:border-gray-200">
      {/* Icon Circle */}
      <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-orange-50 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:from-orange-600 group-hover:to-orange-500 transition-all duration-300">
        <div className="text-primary text-2xl group-hover:text-white transition-colors">
          {icon}
        </div>
      </div>

      {/* Step Number Badge */}
      <div className="inline-block bg-orange-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-3">
        Step {stepNumber}
      </div>

      {/* Title */}
      <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-orange-600 transition-colors">
        {title}
      </h3>

      {/* Description - Always visible */}
      <p className="text-gray-600 text-sm leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default GDeskWorksCard;